export default "__VITE_ASSET__BrFitigb__"